import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeResource } from "../../balancing/TypeResource";
import { actionInventoryInfoAddResource, actionInventoryInfoRemoveResource, } from "../../info/inventory/actionInventoryInfo";
import { actionBuildingsPreSelect } from "../../player-base/buildings/actionBuildings";
import { actionWaterTowerCollectWater } from "../../watertower/actionWaterTower";
import { TypeActionTrade } from "../actionTrade";
export var epicSellProduct = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTrade.Sell), switchMap(function (action) {
        var state = state$.value;
        return deps
            .netSend({
            id: CommandCode.SellProducts,
            props: {
                amount: action.amount,
                itemId: action.itemId,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            var wastes = [
                {
                    amount: Long.fromNumber(res.amount),
                    typeId: res.itemId,
                },
            ];
            var actions = [
                actionInventoryInfoRemoveResource(wastes),
                actionInventoryInfoAddResource(res.earnings),
            ];
            var resourceInfo = selectResourceInfo(res.itemId);
            if (resourceInfo.type === TypeResource.ContractsResources &&
                state.playerBase.buildings.building) {
                actions.push(actionBuildingsPreSelect(state.playerBase.buildings.building, state.playerBase.buildings.buildingCenterCoords));
            }
            else if (resourceInfo.type === TypeResource.Water) {
                actions.push(actionWaterTowerCollectWater());
            }
            return from(actions);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/epics/epicSellProduct.ts
// module id = 2454
// module chunks = 3